<template>
    <div class="json-preview">
      <pre v-html="computedCode"></pre>
    </div>
</template>
<script type="text/babel">

  export default {
    components: {},
    props:{
      jsonObj:{
        type:Object,
        require:true
      }
    },
    data(){
      return {

      }
    },
    computed:{
      computedCode(){
        return this.syntaxHighlight(this.jsonObj)
      }
    },
    methods: {
      syntaxHighlight(json) {
        if (typeof json != 'string') {
          json = JSON.stringify(json, undefined, 2);
        }
        json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
          var cls = 'number';
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = 'key';
            } else {
              cls = 'string';
            }
          } else if (/true|false/.test(match)) {
            cls = 'boolean';
          } else if (/null/.test(match)) {
            cls = 'null';
          }
          return '<span class="' + cls + '">' + match + '</span>';
        });
      }
    }
  }
</script>
<style lang="less">
  .json-preview {
    pre {
      outline: 1px solid #ccc;
      padding: 5px;
      margin: 5px;
      .string { color: green; }
      .number {
        color: darkorange;
        font-size: 14px;
      }
      .boolean { color: blue; }
      .null { color: magenta; }
      .key { color: red; }
    }
  }
 </style>
